import * as React from 'react';
import { IconTooltip, IconTooltipProps } from '~/ui-components/IconToolTip';
import { faCircleQuestion } from '@fortawesome/pro-regular-svg-icons';

export type QuestionTooltipProps = Omit<IconTooltipProps, 'children' | 'icon'>;

export function QuestionTooltip({ ...props }: Readonly<QuestionTooltipProps>) {
   return <IconTooltip icon={faCircleQuestion} {...props} />;
}
